// React
import { useEffect, useMemo, useState } from "react";

//MUI
import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

// Third Party
// Hooks
import useGetReviewDetailsInRange from "@DataPages/hooks/socialMediaReviews/useGetReviewDetailsInRange";

//Components
import SocialMediaReviewsAssociateTable from "./SocialMediaReviewsAssociateTable";
import EmptyBody from "@Layouts/components/Basics/EmptyBody";
import ReviewsDatePicker from "../components/ReviewsDatePicker";

// Assets
import emptyTable from "@/assets/images/commons/empty_table.png";

// Types
import { TSelectionItem } from "../interfaces";
import { IReviewDateRange } from "@DataPages/types/socialMediaReviews/utils";
import { IReviewSiteSummary } from "@DataPages/types/socialMediaReviews/model";

type TSocialMediaReviewProps = Readonly<{
	locationId: string;
	selectedItem: TSelectionItem;
	columns: GridColDef[];
	rows: IReviewSiteSummary[];
	isDataPresent: boolean;
	updatedAt?: string | Date;
	key: string;
	positionName: string;
	onDemand: boolean | undefined;
	tabName: string;
}>;
export default function SocialMediaReviewAssociate(props: TSocialMediaReviewProps) {
	const { onDemand = false, locationId, selectedItem, tabName } = props;
	const { commissionCycleId = "", payPeriodEndDate = "" } = selectedItem ?? {};
	const [selectedDates, setSelectedDates] = useState<IReviewDateRange | null>(null);

	const { isLoading, data } = useGetReviewDetailsInRange("users", {
		commissionCycleId,
		dateRange: selectedDates,
	});

	const reviewsByDateRange = useMemo(() => {
		if (!data) {
			return { columns: [], rows: [] };
		}

		const reviews = data?.usersReviews?.find((item) => item.positionTitle === tabName) ?? { columns: [], rows: [] };
		return { columns: reviews?.columns, rows: reviews?.rows as IReviewSiteSummary[] };
	}, [data, tabName]);

	useEffect(() => {
		return () => {
			setSelectedDates(null);
		};
	}, [commissionCycleId, payPeriodEndDate, locationId]);

	if (!props.isDataPresent) {
		return <EmptyBody image={emptyTable} title="No columns found" bodyHeightClassName="!h-[400px]" />;
	}

	return (
		<Stack width={"auto"} component={"section"} id={`${props.positionName}-section`}>
			<Typography className={"regular-montserrat-label fs-18 "}>{props.positionName}</Typography>

			<ReviewsDatePicker
				containerStyle={{ zIndex: 4, marginBottom: "-40px" }}
				isDisabled={onDemand || isLoading}
				minDate={selectedItem.startDateCommissionCycle}
				maxDate={selectedItem.payPeriodEndDate}
				selectedDates={selectedDates}
				setSelectedDates={setSelectedDates}
			/>
			<SocialMediaReviewsAssociateTable
				locationId={locationId}
				selectedDates={selectedDates}
				selectedItem={selectedItem}
				isDataPresent={props.isDataPresent}
				columns={reviewsByDateRange?.columns?.length ? reviewsByDateRange?.columns : props.columns}
				rows={reviewsByDateRange?.rows?.length ? reviewsByDateRange?.rows : props.rows}
				onDemand={onDemand}
			/>
		</Stack>
	);
}
